import apiClient from '../apiClient';
import { normalizeEmployee } from '../transformers';

export const fetchEmployees = async (config = {}) => {
  const response = await apiClient.get('/employees', config);
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeEmployee).filter(Boolean);
};

export const fetchRemovedEmployees = async () => {
  const response = await apiClient.get('/employees/removed');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeEmployee).filter(Boolean);
};

export const fetchCurrentEmployee = async () => {
  const response = await apiClient.get('/employees/me');
  return response?.data ? normalizeEmployee(response.data) : null;
};

export const updateCurrentEmployeeProfile = async (payload) => {
  const response = await apiClient.patch('/employees/me', payload ?? {});
  return response?.data ? normalizeEmployee(response.data) : null;
};

export const fetchEmployeeById = async (employeeId) => {
  if (!employeeId) {
    throw new Error('Employee id is required to load employee details.');
  }
  const response = await apiClient.get(`/employees/${employeeId}`);
  return response?.data ? normalizeEmployee(response.data) : null;
};

export const deleteEmployee = async (employeeId) => {
  if (!employeeId) {
    throw new Error('Employee id is required to delete an employee.');
  }
  const response = await apiClient.delete(`/employees/${employeeId}`);
  return response?.data ? normalizeEmployee(response.data) : null;
};

export const updateEmployee = async (employeeId, payload) => {
  if (!employeeId) {
    throw new Error('Employee id is required to update an employee.');
  }
  const response = await apiClient.patch(`/employees/${employeeId}`, payload ?? {});
  return normalizeEmployee(response?.data);
};

export const restoreEmployee = async (employeeId) => {
  if (!employeeId) {
    throw new Error('Employee id is required to restore an employee.');
  }
  const response = await apiClient.patch(`/employees/${employeeId}/restore`);
  return response?.data ? normalizeEmployee(response.data) : null;
};

export const fetchEmployeeReviewDetails = async (employeeId) => {
  if (!employeeId) {
    throw new Error('Employee id is required to load review details.');
  }

  const response = await apiClient.get(`/employees/${employeeId}/review`);
  const employee = normalizeEmployee(response?.data?.employee);

  return {
    employee,
    invitation: response?.data?.invitation ?? null,
  };
};

export default {
  fetchEmployees,
  fetchRemovedEmployees,
  fetchCurrentEmployee,
  updateCurrentEmployeeProfile,
  fetchEmployeeById,
  deleteEmployee,
  updateEmployee,
  fetchEmployeeReviewDetails,
  restoreEmployee,
};
